import md5 from 'js-md5'
/* 
md5加密方式
*/
const SecretKey = "cce85461168scude";//加密秘钥字符串key

function newTime(){
	var toDay = new Date()
	var year = toDay.getFullYear() //年
	var month = toDay.getMonth() + 1 < 10 ? '0' + (toDay.getMonth() + 1) : toDay.getMonth() + 1 //月
	var data = toDay.getDate() < 10 ? '0' + toDay.getDate() : toDay.getDate() //日
	var hour = toDay.getHours() < 10 ? '0' + toDay.getHours() : toDay.getHours() //时
	var minute = toDay.getMinutes() < 10 ? '0' + toDay.getMinutes() : toDay.getMinutes() //分
	var second = toDay.getSeconds() < 10 ? '0' + toDay.getSeconds() : toDay.getSeconds() //秒
	return year + month + data + hour + minute + second;
}

export function cdEncrypt(params) {
	let time = newTime();
    params = {
        time: time,
        ...params
    }
    params.sign = md5(SecretKey + time);
    return params;
}